var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5336 1.78833H9.99378V0.888672H9.09412V1.78833H3.15637V0.888672H2.25671V1.78833H1.71692C0.972812 1.78833 0.367432 2.39371 0.367432 3.13782V11.0548C0.367432 11.7989 0.972812 12.4043 1.71692 12.4043H10.5336C11.2777 12.4043 11.8831 11.7989 11.8831 11.0548V3.13782C11.8831 2.39371 11.2777 1.78833 10.5336 1.78833ZM10.9834 11.0548C10.9834 11.3028 10.7816 11.5046 10.5336 11.5046H1.71692C1.46888 11.5046 1.26709 11.3028 1.26709 11.0548V5.11707H10.9834V11.0548ZM10.9834 4.21741H1.26709V3.13782C1.26709 2.88978 1.46888 2.68799 1.71692 2.68799H2.25671V3.58765H3.15637V2.68799H9.09412V3.58765H9.99378V2.68799H10.5336C10.7816 2.68799 10.9834 2.88978 10.9834 3.13782V4.21741Z",
    fill: "#35435E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97607 6.0625H2.07642V6.96216H2.97607V6.0625Z",
    fill: "#35435E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77686 6.0625H3.8772V6.96216H4.77686V6.0625Z",
    fill: "#35435E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57471 6.0625H5.67505V6.96216H6.57471V6.0625Z",
    fill: "#35435E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37549 6.0625H7.47583V6.96216H8.37549V6.0625Z",
    fill: "#35435E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1733 6.0625H9.27368V6.96216H10.1733V6.0625Z",
    fill: "#35435E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97705 7.86523H2.07739V8.76489H2.97705V7.86523Z",
    fill: "#35435E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77686 7.86523H3.8772V8.76489H4.77686V7.86523Z",
    fill: "#35435E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57568 7.86523H5.67603V8.76489H6.57568V7.86523Z",
    fill: "#35435E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37549 7.86523H7.47583V8.76489H8.37549V7.86523Z",
    fill: "#35435E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97705 9.66211H2.07739V10.5618H2.97705V9.66211Z",
    fill: "#35435E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77686 9.66211H3.8772V10.5618H4.77686V9.66211Z",
    fill: "#35435E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57568 9.66211H5.67603V10.5618H6.57568V9.66211Z",
    fill: "#35435E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37549 9.66211H7.47583V10.5618H8.37549V9.66211Z",
    fill: "#35435E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1743 7.86523H9.27466V8.76489H10.1743V7.86523Z",
    fill: "#35435E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f50446d64c0db33a4b69f44a4b4f9bc5.svg";
export { ForwardRef as ReactComponent };